import { apiClient } from '../../axios';
import { GetCaptchaIdResponse } from './types';

export const getCaptchaIdApi = () => apiClient.get<GetCaptchaIdResponse>('/v1/server');
